{
  "subscription": {
    "title": "Our Articles",
    "tag": "blog",
    "description": "Here you can find articles dedicated to renewable energy, sustainability, and the latest industry news."
  },
  "subscription-form": {
    "submit": "Subscribe",
    "placeholder": "name.surname@domain.com",
    "terms": "I agree to receive newsletters and promotional emails.",
    "success": "Successfully subscribed!",
    "error": "Something went wrong. Please try again.",
    "fields": {
      "email": {
        "label": "Email Address",
        "error": "Please enter a valid email address."
      },
      "terms": {
        "error": "You must accept the terms to proceed."
      }
    }
  },
  "backToBlog": "← Back to Blog"
}
